import { doctorsActions } from "../slices/doctorsSlice";
import { toast } from "react-toastify";
import axios from "axios";


//Fetch doctors based on bage number
export function fetchDoctors(pageNumber) {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(
        `https://tabeeb-assyut-api.onrender.com/api/doctors?pageNumber=${pageNumber}`
      );
      dispatch(doctorsActions.setDoctors(data));
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
}
//Get doctors count
export function getDoctorsCount() {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(
        `https://tabeeb-assyut-api.onrender.com/api/doctors/count`
      );
      dispatch(doctorsActions.setDoctorsCount(data));
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
}
//Create Doctor
export function createDoctor(newDoctor) {
  return async (dispatch, getState) => {
    try {
      dispatch(doctorsActions.setLoading());
      await axios.post(
        `https://tabeeb-assyut-api.onrender.com/api/doctors`,
        newDoctor,
        {
          headers: {
            Authorization: "Bearer " + getState().auth.user.token,
          },
        }
      );
      dispatch(doctorsActions.setIsDoctorCreated());
      setTimeout(() => dispatch(doctorsActions.clearIsDoctorCreated()), 2000); //2 seconds
    } catch (error) {
      toast.error("حدث خطا ما");
      dispatch(doctorsActions.clearLoading());
    }
  };
}

//Fetch single doctor
export function fetchSingleDoctor(doctorId) {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(
        `https://tabeeb-assyut-api.onrender.com/api/doctors/${doctorId}`
      );
      dispatch(doctorsActions.setDoctor(data));
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
}
//Toggle Like doctor
export function toggleLikeDoctor(doctorId) {
  return async (dispatch, getState) => {
    try {
      const { data } = await axios.put(
        `https://tabeeb-assyut-api.onrender.com/api/doctors/like/${doctorId}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + getState().auth.user.token,
          },
        }
      );
      dispatch(doctorsActions.setLike(data));
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
}
//Update doctor image
export function updateDoctorImage(newImage, doctorId) {
  return async (dispatch, getState) => {
    try {
      await axios.put(
        `https://tabeeb-assyut-api.onrender.com/api/doctors/update-image/${doctorId}`,
        newImage,
        {
          headers: {
            Authorization: "Bearer " + getState().auth.user.token,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.success("تم تحديث الصورة بنجاح :(");
    } catch (error) {
      toast.error("حدث خطأ ما فى تحديث صورة الطبيب");
    }
  };
}
//Update doctor
export function updateDoctorDetails(newDoctor, doctorId) {
  return async (dispatch, getState) => {
    try {
      const { data } = await axios.put(
        `https://tabeeb-assyut-api.onrender.com/api/doctors/${doctorId}`,
        newDoctor,
        {
          headers: {
            Authorization: "Bearer " + getState().auth.user.token,
          },
        }
      );
      dispatch(doctorsActions.setDoctor(data));
      toast.success("تم تحديث البيانات بنجاح ");
    } catch (error) {
      toast.error("حدث خطأ ما فى تحديث بيانات الطبيب");
    }
  };
}
//Delete doctor
export function deleteDoctor(doctorId) {
  return async (dispatch, getState) => {
    try {
      const { data } = await axios.delete(
        `https://tabeeb-assyut-api.onrender.com/api/doctors/${doctorId}`,
        {
          headers: {
            Authorization: "Bearer " + getState().auth.user.token,
          },
        }
      );
      dispatch(doctorsActions.deleteDoctor(data.doctorId));
      toast.success(data.message);
    } catch (error) {
      toast.error("حدث خطأ ما فى حذف بيانات الطبيب");
    }
  };
}

//Fetch all doctors
export function getAllDoctors() {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(
        `https://tabeeb-assyut-api.onrender.com/api/doctors`
      );
      dispatch(doctorsActions.setDoctors(data));
    } catch (error) {
      toast.error("حدث خطأ ما فى سترجاع بيانات الاطباء");
    }
  };
}
